import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    appBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    appBarLeftContent: {
        display: "flex",
        alignItems: "center",
        marginLeft: "20px",
    },
    appBarRightContent: {
        display: "flex",
        alignItems: "center",
    },
    appBarLanguageDropdown: {
        "& label": {
            display: "none",
        },
        "& .MuiInputBase-root": {
            width: "initial !important",
            boxShadow: "none !important",
            marginBottom: 0,
            backgroundColor: `transparent !important`,
        },
        "& .MuiSelect-select": {
            minWidth: "90px !important",
        },
        "& .MuiBox-root": {
            color: `${theme.palette.primary.main} !important`,
        },
        "& .MuiSvgIcon-root": {
            color: `${theme.palette.primary.main} !important`,
            width: `16px !important`,
            height: `16px !important`,
            top: `calc(50% - 0.3em) !important`,
        },
        " & fieldset": {
            border: "none !important",
        },
    },
    toolbarIconButton: {
        width: `20px !important`,
        height: `20px !important`,
        marginRight: `2px !important`,
        backgroundColor: `${theme.palette.info.main} !important`,
        padding: 0,
    },
    avatar: {
        width: `27.5px !important`,
        height: `27.5px !important`,
    },
    menuButton: {
        display: "flex !important",
        gap: "16px !important",
        fontSize: "14px !important",
        fontWeight: `400 !important`,
        fontFamily: "Open Sans !important",
        textTransform: "none !important" as "none",
        "&:hover": {
            backgroundColor: "initial !important",
        },
    },
    expandMoreIcon: {
        width: `16px !important`,
        height: `16px !important`,
    },
    expandMoreIconRotated: {
        width: `16px !important`,
        height: `16px !important`,
        transform: "rotate(180deg) !important",
    },
    divider: {
        borderColor: `${theme.palette.border.divider} !important`,
        marginLeft: "12px !important",
        marginRight: "12px !important",
    },
    appMenu: {
        width: `27.5px !important`,
        height: `27.5px !important`,
        color: `${theme.palette.primary.main} !important`,
    },
}));

export const paperProps = {
    elevation: 0,
    sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
    },
};
